import { render, staticRenderFns } from "./VirtualCareChat.vue?vue&type=template&id=08e9da4d&"
import script from "./VirtualCareChat.vue?vue&type=script&lang=js&"
export * from "./VirtualCareChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports